<template>
  <div id="inline-filters" class="mt-2" v-if="ifStore.isAnyFilterActive">
    <div class="flex flex-wrap justify-start gap-2">
      <template v-if="ifStore.isFilterActive && showCategoryToggles" >
        <filtersToggleBadge
          v-for="(key, value) in ifStore.activeCategories"
          :key="key"
          :category="key"
          :enabled="true"
          @update:enabled="toggle($event, key)"
        />
      </template>
      <filtersToggleBadge
        v-if="ifStore.isYearFilterActive"
        :category="`${ifStore.sliderYears[0]}-${ifStore.sliderYears[1]}`"
        :enabled="true"
        @update:enabled="ifStore.resetYearFilter()"
        force-background-color="#ffff"
        class="border border-gray-900"
      />
    </div>
  </div>
</template>

<script setup>
const ifStore = useInterfaceStore();
const props = defineProps({
  showCategoryToggles: {
    type: Boolean,
    default: true,
  },
 
});

const toggle = (value, key) => {
  if(ifStore.isFilterActive === false && value === false) {
    ifStore.disableAllCategories(); // all selected- >click one -> one selected
    ifStore.categoriesFilter.set(key, true);
  }
  //one selected-> deselect -> all selected
  else if( ifStore.activeFilterKeys.length === 1 && !value && key === ifStore.activeFilterKeys[0]){
    ifStore.enableAllCategories()
  }
  else ifStore.categoriesFilter.set(key, value);
};
</script>

<style lang="scss" scoped></style>
